import { useMemo, useState } from 'react';
import type { ProjectDetail } from '@/types/odoo';
import { useProjectViewStore } from '@/stores/projectView';
import { pickInstallateurTask, todayIso, useChosenTaskWins, type ShownFase } from './installateurTaakDay';
import { ProjectInfoSection, TaakomschrijvingSection, InstallateursSection } from './InstallateurTaakInfo';
import { GrondplannenSection } from './InstallateurGrondplannen';
import { VerlegschemaSection } from './InstallateurVerlegschema';

interface InstallateurTaakContentProps {
  projectId: number;
  projectName: string;
  detail: ProjectDetail;
  /** The Dashboard's selected fase; picks the day shown (null on the standalone tab). */
  faseId?: ShownFase;
}

/**
 * The Installateur Taak blocks shared by the Dashboard's first section and the
 * standalone tab (EasyKit, no-dashboard roles). The standalone tab adds its
 * Collectoren Overzicht below; the Dashboard has its own Collectoren section.
 */
export function InstallateurTaakContent({ projectId, projectName, detail, faseId = null }: InstallateurTaakContentProps) {
  const [plansRefreshKey, setPlansRefreshKey] = useState(0);
  const activeTaskId = useProjectViewStore((s) => s.activeTaskId);
  const activeTaskChosen = useChosenTaskWins(useProjectViewStore((s) => s.taskChoice), faseId);
  // One shown day for both Taakomschrijving and Installateurs.
  const task = useMemo(
    () =>
      pickInstallateurTask(detail.projectTasks, {
        faseId: typeof faseId === 'number' ? faseId : null,
        activeTaskId,
        activeTaskChosen,
        today: todayIso(),
      }),
    [detail.projectTasks, faseId, activeTaskId, activeTaskChosen],
  );

  return (
    <>
      <ProjectInfoSection detail={detail} />
      <TaakomschrijvingSection projectTasks={detail.projectTasks} projectId={projectId} task={task} />
      <InstallateursSection detail={detail} task={task} />
      <GrondplannenSection projectId={projectId} projectName={projectName} refreshKey={plansRefreshKey} />
      <VerlegschemaSection projectId={projectId} onSaved={() => setPlansRefreshKey((k) => k + 1)} />
    </>
  );
}
